import Attachments from './Attachments';

export default Attachments;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/Attachments/index.js